export const tableColumnWidths = {
  suites: {
    name: { flex: 1.35, minWidth: 300 },
    latestStatus: { flex: 0.42, minWidth: 126, maxWidth: 152 },
    lastExecuted: { flex: 0.34, minWidth: 108, maxWidth: 132 },
    executions: { flex: 0.48, minWidth: 148, maxWidth: 184 },
    latestTests: { flex: 0.58, minWidth: 168, maxWidth: 220 },
    metrics: { flex: 0.72, minWidth: 248, maxWidth: 320 },
    actions: { width: 44 },
  },
  pipelines: {
    name: { flex: 1 },
    latestStatus: { flex: 0.5 },
    latestStages: { flex: 0.75 },
    latestJobs: { flex: 0.75 },
    runs: { flex: 0.75 },
    metrics: { flex: 1 },
    actions: { flex: 0.1 },
  },
  tests: {
    name: { flex: 1.35, minWidth: 300 },
    suite: { flex: 0.42, minWidth: 136, maxWidth: 184 },
    latestStatus: { flex: 0.42, minWidth: 126, maxWidth: 152 },
    lastExecuted: { flex: 0.34, minWidth: 108, maxWidth: 132 },
    executions: { flex: 0.5, minWidth: 148, maxWidth: 188 },
    metrics: { flex: 0.76, minWidth: 256, maxWidth: 328 },
    actions: { width: 44 },
  },
  executionRuns: {
    name: { flex: 1 },
    status: { flex: 0.5 },
    suites: { flex: 0.5 },
    tests: { flex: 0.5 },
    details: { flex: 0.5 },
    actions: { flex: 0.1 },
  },
  suiteRuns: {
    name: { flex: 1 },
    run: { flex: 0.5 },
    status: { flex: 0.5 },
    tests: { flex: 0.5 },
    output: { flex: 0.5 },
    details: { flex: 0.5 },
    actions: { flex: 0.1 },
  },
  testRuns: {
    name: { flex: 1 },
    run: { flex: 0.5 },
    status: { flex: 0.5 },
    output: { flex: 0.75 },
    details: { flex: 0.5 },
    actions: { flex: 0.1 },
  },
  resultsFiles: {
    file: { flex: 1 },
    executionRuns: { flex: 0.5 },
    suites: { flex: 0.5 },
    tests: { flex: 0.5 },
    details: { flex: 0.5 },
    actions: { flex: 0.1 },
  },
  uploads: {
    id: { flex: 1 },
    status: { flex: 0.5 },
    error: { flex: 1 },
    actions: { flex: 0.1 },
  },
} as const;
